/** Shown once on employee login after API session expiry redirect. */
export const EMPLOYEE_SESSION_EXPIRED_TOAST_MESSAGE =
  'Your session has expired. Please log in again.';

export const EMPLOYEE_SESSION_EXPIRED_FLASH_KEY = 'spence:employee:session-expired-toast';

export function persistEmployeeSessionExpiredFlash(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage?.setItem(EMPLOYEE_SESSION_EXPIRED_FLASH_KEY, '1');
  } catch {
    // Ignore quota / private mode — redirect still proceeds.
  }
}

/** Read-and-clear so the toast shows at most once after redirect. */
export function consumeEmployeeSessionExpiredFlash(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const stored = window.sessionStorage?.getItem(EMPLOYEE_SESSION_EXPIRED_FLASH_KEY);
    if (stored !== '1') {
      return false;
    }

    window.sessionStorage?.removeItem(EMPLOYEE_SESSION_EXPIRED_FLASH_KEY);
    return true;
  } catch {
    return false;
  }
}
